/**
 * Moves the item at the given index to the start of the array.
 * Returns a new array with the selected item first.
 *
 * @param array - The original array
 * @param index - Index of the item to move to the front
 * @returns A new array with the item at `index` moved to the front
 */
export const moveItemToFront = <T>(array: T[], index: number): T[] => {
  if (!Array.isArray(array)) {
    throw new TypeError('Expected an array as the first argument');
  }

  if (index < 0 || index >= array.length) {
    throw new RangeError('Index out of bounds');
  }

  const item = array[index]!;

  // Create a new array with the item first, followed by the rest (excluding that item)
  return [item, ...array.slice(0, index), ...array.slice(index + 1)];
};
